import React from "react";
import Forbidden from "../../../assets/svgs/forbidden.svg";
import { Box, Image, Text } from "@chakra-ui/react";

const ForbiddenLayout = () => {
  return (
    <Box
      bgColor={"#F5F4FA"}
      h={"100vh"}
      display={"flex"}
      flexDir={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      margin={"auto"}
      padding={"auto"}
      zIndex={1000}
    >
      <Image src={Forbidden} alt="Forbidden" />
      <Text
        fontFamily={"Poppins"}
        fontWeight={"600"}
        fontSize={"24px"}
        lineHeight={"30px"}
        color={"#000000D9"}
        mb={"20px"}
      >
        Forbidden
      </Text>
      <Text
        fontFamily={"Poppins"}
        fontWeight={"400"}
        fontSize={"16px"}
        lineHeight={"20px"}
        color={"#000000D9"}
      >
        Sorry, you don't have access to this page.
      </Text>
      <Text
        fontFamily={"Poppins"}
        fontWeight={"400"}
        fontSize={"16px"}
        lineHeight={"20px"}
        color={"#000000D9"}
      >
        Taking you back to the login page shortly.
      </Text>
    </Box>
  );
};

export default ForbiddenLayout;
